<template>
  <div class="dashboard">
    <!-- Tabs -->
    <b-card no-body>
      <b-tabs card>
   

        <!-- Tab 2 - Events -->
        <b-tab title="Events" active>
          <b-card-text>
            <div>
              <b-overlay :show="eventsLoading" rounded="sm" no-fade>
                <b-row class="mb-1">
                  <b-col
                    cols="12"
                    md="7"
                    class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                  >
                    <h3 class="ml-1">Events</h3>
                  </b-col>
                  <b-col
                    cols="12"
                    md="5"
                    class="d-flex align-items-center justify-content-end"
                  >
                    <div class="d-flex align-items-center">
                      <b-form-input
                        v-model="eventsFilter"
                        class="d-inline-block mr-1"
                        placeholder="Search..."
                      />
                    </div>
                  </b-col>
                </b-row>

                <div style="max-width: 100%; overflow-y: auto;">
                  <b-table
                    striped
                    hover
                    bordered
                    :outlined="true"
                    :fields="eventsFields"
                    :items="filteredEvents"
                    responsive="sm"
                    :small="true"
                    class="table table-sm"
                    :filter="eventsFilter"
                    @filtered="onEventsFiltered"
                    show-empty
                    empty-text="No matching records found"
                    :current-page="eventsCurrentPage"
                    :per-page="eventsPerPage"
                    :tbody-tr-class="rowClass"
                    @row-clicked="viewEvent($event.id)"
                  >
                    <template #cell(course)="{ item }">
                      <div
                        style="min-width: 250px; max-width: 400px;"
                        class="p-25"
                      >
                        <p class="mb-0 font-weight-600">
                          {{
                            item.course_title ||
                              (item.course && item.course.title)
                          }}
                        </p>
                        <small
                          class="text-muted text-truncate d-block"
                          v-if="item.title_override"
                          :title="item.title_override"
                          >{{ item.title_override }}</small
                        >

                        <div v-if="item && item.is_eft" class="mt-25">
                          <b-badge variant="light-info">Educational Fee Training</b-badge>
                        </div>
                      </div>
                    </template>

                    <template #cell(dates)="{ item }">
                      <div style="min-width: 150px;">
                        <!-- Show dates for each session/part -->
                        <div v-if="item.sessions && item.sessions.length > 0">
                          <div
                            v-for="(session, index) in item.sessions"
                            :key="session.id"
                            class="mb-1"
                            style="font-size: 0.85em;"
                          >
                            <strong>Part {{ index + 1 }}:</strong><br />
                            <span>{{ formatDate(session.start_at) }}</span>
                            <span
                              v-if="
                                session.end_at &&
                                  session.start_at !== session.end_at
                              "
                            >
                              - {{ formatDate(session.end_at) }}
                            </span>
                          </div>
                        </div>
                        <!-- Fallback to date_range if no sessions -->
                        <div
                          v-else-if="
                            item.date_range &&
                              (item.date_range.start || item.date_range.end)
                          "
                        >
                          <span>{{ formatDate(item.date_range.start) }}</span>
                          <span v-if="item.date_range.end">
                            - {{ formatDate(item.date_range.end) }}</span
                          >
                        </div>
                        <div v-else>-</div>
                      </div>
                    </template>
                    <template #cell(venue)="{ item }">
                      <div style="min-width: 100px;">
                        <!-- Show venue for each session/part -->
                        <div v-if="item.sessions && item.sessions.length > 0">
                          <div
                            v-for="(session, index) in item.sessions"
                            :key="session.id"
                            class="mb-1"
                            style="font-size: 0.85em;"
                          >
                            <strong>Part {{ index + 1 }}:</strong><br />
                            <span>{{ session.venue || "-" }}</span>
                          </div>
                        </div>
                        <!-- Fallback to first session venue -->
                        <div v-else>
                          <span>{{
                            (firstSession(item) && firstSession(item).venue) ||
                              "-"
                          }}</span>
                        </div>
                      </div>
                    </template>
                    <template #cell(time)="{ item }">
                      <div style="min-width: 120px;">
                        <!-- Show time for each session/part -->
                        <div v-if="item.sessions && item.sessions.length > 0">
                          <div
                            v-for="(session, index) in item.sessions"
                            :key="session.id"
                            class="mb-1"
                            style="font-size: 0.85em;"
                          >
                            <strong>Part {{ index + 1 }}:</strong><br />
                            <span v-if="session.start_at">
                              {{ formatTime(session.start_at) }}
                              <span v-if="session.end_at">
                                - {{ formatTime(session.end_at) }}</span
                              >
                            </span>
                            <span v-else>-</span>
                          </div>
                        </div>
                        <!-- Fallback to first session time -->
                        <div v-else>
                          <span v-if="firstSession(item)"
                            >{{ formatTime(firstSession(item).start_at) }} -
                            {{ formatTime(firstSession(item).end_at) }}</span
                          >
                          <span v-else>-</span>
                        </div>
                      </div>
                    </template>
                    <template #cell(trainer)="{ item }">
                      <div style="min-width: 100px;">
                        <!-- Show trainer for each session/part -->
                        <div v-if="item.sessions && item.sessions.length > 0">
                          <div
                            v-for="(session, index) in item.sessions"
                            :key="session.id"
                            class="mb-1"
                            style="font-size: 0.85em;"
                          >
                            <strong>Part {{ index + 1 }}:</strong><br />
                            <span>{{ session.trainer || "-" }}</span>
                          </div>
                        </div>
                        <!-- Fallback to first session trainer -->
                        <div v-else>
                          <span>{{
                            (firstSession(item) &&
                              firstSession(item).trainer) ||
                              "-"
                          }}</span>
                        </div>
                      </div>
                    </template>
                    <template #cell(max)="{ item }">
                      <div style="min-width: 50px;" class="text-center">
                        <span
                          >{{ item.accepted_count || 0 }}/{{
                            item.max_participants
                          }}</span
                        >
                      </div>
                    </template>
                    <template #cell(status)="{ item }">
                      <div style="min-width: 80px;" class="text-center">
                        <b-badge :variant="statusVariant(item.status)">{{
                          item.status
                        }}</b-badge>
                      </div>
                    </template>
                    <template #cell(my_status)="{ item }">
                      <div style="min-width: 120px;" class="text-center">
                        <b-badge
                          :variant="getMyStatusVariant(item)"
                          :class="{
                            'text-dark':
                              getMyStatusText(item) === 'Not Applied',
                          }"
                        >
                          {{ getMyStatusText(item) }}
                        </b-badge>
                      </div>
                    </template>
                    <template #cell(actions)="{ item }">
                      <div
                        style="min-width: 240px;"
                        class="d-flex align-items-center justify-content-center"
                      >
                        <b-button
                          variant="outline-primary"
                          class="mr-1 p-50"
                          @click.stop="
                            $router.push({
                              name: 'dashboard-event-view',
                              params: { id: item.id },
                              query: { from: 'dashboard' },
                            })
                          "
                        >
                          <i class="fa-solid fa-eye mr-25"></i
                          ><span> View</span>
                        </b-button>

                        <!-- Apply Button (show if user hasn't applied or has withdrawn, and not Manager/Admin) -->
                        <b-button
                          v-if="
                            canApplyToEvent() &&
                              item.status === 'open' &&
                              (!getUserApplication(item.id) ||
                                (getUserApplication(item.id) &&
                                  getUserApplication(item.id).status ===
                                    'withdrawn'))
                          "
                          variant="success"
                          class="mr-1 p-50"
                          @click.stop="openApplyModal(item)"
                        >
                          <i class="fa-solid fa-user-plus mr-25"></i
                          ><span>
                            {{
                              isEventFull(item) ? "Join Waitlist" : "Apply"
                            }}</span
                          >
                        </b-button>
                        <!-- Withdraw Button (show if user has applied and can withdraw, and not Manager/Admin) -->
                        <b-button
                          v-else-if="
                            canApplyToEvent() &&
                              item.status === 'open' &&
                              canWithdraw(getUserApplication(item.id))
                          "
                          variant="warning"
                          class="mr-1 p-50"
                          @click.stop="withdrawFromEvent(item)"
                        >
                          <i class="fa-solid fa-user-minus mr-25"></i
                          ><span> Withdraw</span>
                        </b-button>

                        <!-- Special Needs Button (show if user has an active application) -->
                        <b-button
                          v-if="
                            getUserApplication(item.id) &&
                              !['withdrawn', 'cancelled'].includes(getUserApplication(item.id).status)
                          "
                          variant="outline-info"
                          class="p-50"
                          @click.stop="openSpecialNeedsModal(item)"
                        >
                          <i class="fa-solid fa-heart-pulse mr-25"></i><span> Special Needs</span>
                        </b-button>
                      </div>
                    </template>
                  </b-table>
                </div>

                <div class="mx-2 mb-1 mt-1">
                  <b-row>
                    <b-col
                      cols="12"
                      sm="6"
                      class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                      <span class="text-muted">
                        Showing {{ eventsDataMeta.from }} to
                        {{ eventsDataMeta.to }} of
                        {{ eventsDataMeta.of }} entries
                      </span>
                    </b-col>
                    <b-col
                      cols="12"
                      sm="6"
                      class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >
                      <b-pagination
                        v-model="eventsCurrentPage"
                        :total-rows="eventsTotalRows"
                        :per-page="eventsPerPage"
                        first-number
                        last-number
                        class="mb-0 mt-1 mt-sm-0"
                        prev-class="prev-item"
                        next-class="next-item"
                      >
                        <template #prev-text
                          ><feather-icon icon="ChevronLeftIcon" size="18"
                        /></template>
                        <template #next-text
                          ><feather-icon icon="ChevronRightIcon" size="18"
                        /></template>
                      </b-pagination>
                    </b-col>
                  </b-row>
                </div>
              </b-overlay>
            </div>
          </b-card-text>
        </b-tab>

        <b-tab title="Passed Events">
          <b-card-text>
            <div>
              <b-overlay :show="passedEventsLoading" rounded="sm" no-fade>
                <b-row class="mb-1">
                  <b-col
                    cols="12"
                    md="7"
                    class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                  >
                    <h3 class="ml-1">Passed Events</h3>
                  </b-col>
                  <b-col
                    cols="12"
                    md="5"
                    class="d-flex align-items-center justify-content-end"
                  >
                    <div class="d-flex align-items-center">
                      <b-form-input
                        v-model="passedEventsFilter"
                        class="d-inline-block mr-1"
                        placeholder="Search..."
                      />
                    </div>
                  </b-col>
                </b-row>

                <div style="max-width: 100%; overflow-y: auto;">
                  <b-table
                    striped
                    hover
                    bordered
                    :outlined="true"
                    :fields="eventsFields"
                    :items="filteredPassedEvents"
                    responsive="sm"
                    :small="true"
                    class="table table-sm"
                    :filter="passedEventsFilter"
                    @filtered="onPassedEventsFiltered"
                    show-empty
                    empty-text="No matching records found"
                    :current-page="passedEventsCurrentPage"
                    :per-page="passedEventsPerPage"
                    :tbody-tr-class="rowClass"
                    @row-clicked="viewEvent($event.id)"
                  >
                    <template #cell(course)="{ item }">
                      <div style="min-width: 250px; max-width: 400px;" class="p-25">
                        <p class="mb-0 font-weight-600">
                          {{ item.course_title || (item.course && item.course.title) }}
                        </p>
                        <small
                          class="text-muted text-truncate d-block"
                          v-if="item.title_override"
                          :title="item.title_override"
                          >{{ item.title_override }}</small
                        >

                        <div v-if="item && item.is_eft" class="mt-25">
                          <b-badge variant="light-info">Educational Fee Training</b-badge>
                        </div>
                      </div>
                    </template>

                    <template #cell(dates)="{ item }">
                      <div style="min-width: 150px;">
                        <div v-if="item.sessions && item.sessions.length > 0">
                          <div
                            v-for="(session, index) in item.sessions"
                            :key="session.id"
                            class="mb-1"
                            style="font-size: 0.85em;"
                          >
                            <strong>Part {{ index + 1 }}:</strong><br />
                            <span>{{ formatDate(session.start_at) }}</span>
                            <span
                              v-if="session.end_at && session.start_at !== session.end_at"
                            >
                              - {{ formatDate(session.end_at) }}
                            </span>
                          </div>
                        </div>
                        <div v-else-if="item.date_range && (item.date_range.start || item.date_range.end)">
                          <span>{{ formatDate(item.date_range.start) }}</span>
                          <span v-if="item.date_range.end">
                            - {{ formatDate(item.date_range.end) }}</span
                          >
                        </div>
                        <div v-else>-</div>
                      </div>
                    </template>

                    <template #cell(venue)="{ item }">
                      <div style="min-width: 100px;">
                        <div v-if="item.sessions && item.sessions.length > 0">
                          <div
                            v-for="(session, index) in item.sessions"
                            :key="session.id"
                            class="mb-1"
                            style="font-size: 0.85em;"
                          >
                            <strong>Part {{ index + 1 }}:</strong><br />
                            <span>{{ session.venue || "-" }}</span>
                          </div>
                        </div>
                        <div v-else>
                          <span>{{ (firstSession(item) && firstSession(item).venue) || "-" }}</span>
                        </div>
                      </div>
                    </template>

                    <template #cell(time)="{ item }">
                      <div style="min-width: 120px;">
                        <div v-if="item.sessions && item.sessions.length > 0">
                          <div
                            v-for="(session, index) in item.sessions"
                            :key="session.id"
                            class="mb-1"
                            style="font-size: 0.85em;"
                          >
                            <strong>Part {{ index + 1 }}:</strong><br />
                            <span v-if="session.start_at">
                              {{ formatTime(session.start_at) }}
                              <span v-if="session.end_at">
                                - {{ formatTime(session.end_at) }}</span
                              >
                            </span>
                            <span v-else>-</span>
                          </div>
                        </div>
                        <div v-else>
                          <span v-if="firstSession(item)">
                            {{ formatTime(firstSession(item).start_at) }} -
                            {{ formatTime(firstSession(item).end_at) }}
                          </span>
                          <span v-else>-</span>
                        </div>
                      </div>
                    </template>

                    <template #cell(trainer)="{ item }">
                      <div style="min-width: 100px;">
                        <div v-if="item.sessions && item.sessions.length > 0">
                          <div
                            v-for="(session, index) in item.sessions"
                            :key="session.id"
                            class="mb-1"
                            style="font-size: 0.85em;"
                          >
                            <strong>Part {{ index + 1 }}:</strong><br />
                            <span>{{ session.trainer || "-" }}</span>
                          </div>
                        </div>
                        <div v-else>
                          <span>{{ (firstSession(item) && firstSession(item).trainer) || "-" }}</span>
                        </div>
                      </div>
                    </template>

                    <template #cell(max)="{ item }">
                      <div style="min-width: 50px;" class="text-center">
                        <span>{{ item.accepted_count || 0 }}/{{ item.max_participants }}</span>
                      </div>
                    </template>

                    <template #cell(status)="{ item }">
                      <div style="min-width: 80px;" class="text-center">
                        <b-badge :variant="statusVariant(item.status)">{{ item.status }}</b-badge>
                      </div>
                    </template>

                    <template #cell(my_status)="{ item }">
                      <div style="min-width: 120px;" class="text-center">
                        <b-badge
                          :variant="getMyStatusVariant(item)"
                          :class="{ 'text-dark': getMyStatusText(item) === 'Not Applied' }"
                        >
                          {{ getMyStatusText(item) }}
                        </b-badge>
                      </div>
                    </template>

                    <template #cell(actions)="{ item }">
                      <div style="min-width: 240px;" class="d-flex align-items-center justify-content-center">
                        <b-button
                          variant="outline-primary"
                          class="mr-1 p-50"
                          @click.stop="
                            $router.push({
                              name: 'dashboard-event-view',
                              params: { id: item.id },
                              query: { from: 'dashboard' },
                            })
                          "
                        >
                          <i class="fa-solid fa-eye mr-25"></i><span> View</span>
                        </b-button>
                      </div>
                    </template>
                  </b-table>
                </div>

                <div class="mx-2 mb-1 mt-1">
                  <b-row>
                    <b-col
                      cols="12"
                      sm="6"
                      class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                      <span class="text-muted">
                        Showing {{ passedEventsDataMeta.from }} to
                        {{ passedEventsDataMeta.to }} of
                        {{ passedEventsDataMeta.of }} entries
                      </span>
                    </b-col>
                    <b-col
                      cols="12"
                      sm="6"
                      class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >
                      <b-pagination
                        v-model="passedEventsCurrentPage"
                        :total-rows="passedEventsTotalRows"
                        :per-page="passedEventsPerPage"
                        first-number
                        last-number
                        class="mb-0 mt-1 mt-sm-0"
                        prev-class="prev-item"
                        next-class="next-item"
                      >
                        <template #prev-text
                          ><feather-icon icon="ChevronLeftIcon" size="18"
                        /></template>
                        <template #next-text
                          ><feather-icon icon="ChevronRightIcon" size="18"
                        /></template>
                      </b-pagination>
                    </b-col>
                  </b-row>
                </div>
              </b-overlay>
            </div>
          </b-card-text>
        </b-tab>

        <!-- Tab 2.5 - Administrator Events -->
        <b-tab title="Administrator Events" v-if="canViewApplicationsTab">
          <b-card-text>
            <div>
              <b-overlay :show="adminEventsLoading" rounded="sm" no-fade>
                <b-row class="mb-1">
                  <b-col
                    cols="12"
                    md="7"
                    class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                  >
                    <h3 class="ml-1">Administrator Events</h3>
                  </b-col>
                  <b-col
                    cols="12"
                    md="5"
                    class="d-flex align-items-center justify-content-end"
                  >
                    <div class="d-flex align-items-center">
                      <b-form-input
                        v-model="adminEventsFilter"
                        class="d-inline-block mr-1"
                        placeholder="Search..."
                      />
                    </div>
                  </b-col>
                </b-row>

                <div style="max-width: 100%; overflow-y: auto;">
                  <b-table
                    :items="adminFilteredEvents"
                    :fields="adminEventsFields"
                    striped
                    hover
                    small
                    show-empty
                    empty-text="No events found"
                    :filter="adminEventsFilter"
                    @filtered="onAdminEventsFiltered"
                    :current-page="adminEventsCurrentPage"
                    :per-page="adminEventsPerPage"
                    :tbody-tr-class="rowClass"
                  >
                    <!-- Course Title -->
                    <template #cell(course_title)="{ item }">
                      <div style="min-width:220px;">
                        <p class="mb-0 font-weight-600">{{ item.course_title }}</p>
                        <small class="text-muted" v-if="item.title_override">
                          {{ item.title_override }}
                        </small>

                        <div v-if="item && item.is_eft" class="mt-25">
                          <b-badge variant="light-info">Educational Fee Training</b-badge>
                        </div>
                      </div>
                    </template>
                    <!-- Dates -->
                    <template #cell(dates)="{ item }">
                      <div style="min-width:150px;">
                        <div v-if="item.sessions && item.sessions.length">
                          <div v-for="(session, index) in item.sessions" :key="session.id" class="mb-1" style="font-size:0.85em;">
                            <strong>Part {{ index + 1 }}:</strong><br />
                            <span>{{ formatDate(session.start_at) }}</span>
                            <span v-if="session.end_at && session.start_at !== session.end_at"> - {{ formatDate(session.end_at) }}</span>
                          </div>
                        </div>
                        <div v-else-if="item.date_range && (item.date_range.start || item.date_range.end)">
                          <span>{{ formatDate(item.date_range.start) }}</span>
                          <span v-if="item.date_range.end"> - {{ formatDate(item.date_range.end) }}</span>
                        </div>
                        <div v-else>-</div>
                      </div>
                    </template>
                    <!-- Venue -->
                    <template #cell(venue)="{ item }">
                      <div style="min-width:100px;">
                        <div v-if="item.sessions && item.sessions.length">
                          <div v-for="(session, index) in item.sessions" :key="session.id" class="mb-1" style="font-size:0.85em;">
                            <strong>Part {{ index + 1 }}:</strong><br />
                            <span>{{ session.venue || '-' }}</span>
                          </div>
                        </div>
                        <div v-else>
                          <span>{{ (firstSession(item) && firstSession(item).venue) || '-' }}</span>
                        </div>
                      </div>
                    </template>
                    <!-- Time -->
                    <template #cell(time)="{ item }">
                      <div style="min-width:120px;">
                        <div v-if="item.sessions && item.sessions.length">
                          <div v-for="(session, index) in item.sessions" :key="session.id" class="mb-1" style="font-size:0.85em;">
                            <strong>Part {{ index + 1 }}:</strong><br />
                            <span v-if="session.start_at">
                              {{ formatTime(session.start_at) }}
                              <span v-if="session.end_at"> - {{ formatTime(session.end_at) }}</span>
                            </span>
                            <span v-else>-</span>
                          </div>
                        </div>
                        <div v-else>
                          <span v-if="firstSession(item)">{{ formatTime(firstSession(item).start_at) }} - {{ formatTime(firstSession(item).end_at) }}</span>
                          <span v-else>-</span>
                        </div>
                      </div>
                    </template>
                    <!-- Trainer -->
                    <template #cell(trainer)="{ item }">
                      <div style="min-width:100px;">
                        <div v-if="item.sessions && item.sessions.length">
                          <div v-for="(session, index) in item.sessions" :key="session.id" class="mb-1" style="font-size:0.85em;">
                            <strong>Part {{ index + 1 }}:</strong><br />
                            <span>{{ session.trainer || '-' }}</span>
                          </div>
                        </div>
                        <div v-else>
                          <span>{{ (firstSession(item) && firstSession(item).trainer) || '-' }}</span>
                        </div>
                      </div>
                    </template>
                    <!-- Max -->
                    <template #cell(max)="{ item }">
                      <div style="min-width:50px;" class="text-center">
                        <span>{{ item.accepted_count || 0 }}/{{ item.max_participants }}</span>
                      </div>
                    </template>
                    <!-- Event Status -->
                    <template #cell(status)="{ item }">
                      <b-badge :variant="statusVariant(item.status)">{{ item.status }}</b-badge>
                    </template>
                    <!-- Applications Count -->
                    <template #cell(applications_count)="{ item }">
                      {{ item.applications ? item.applications.length : 0 }}
                    </template>
                    <!-- Toggle Details Button -->
                    <template #cell(_details)="row">
                      <b-button size="sm" variant="outline-primary" @click="row.toggleDetails" :title="row.detailsShowing ? 'Hide Applications' : 'Show Applications'">
                        <feather-icon :icon="row.detailsShowing ? 'ChevronUpIcon' : 'ChevronDownIcon'" size="16" class="mr-25" />
                        {{ row.detailsShowing ? 'Hide' : 'View' }}
                      </b-button>
                    </template>
                    <!-- Row Details: Nested Applications Plain Table -->
                    <template #row-details="{ item }">
                      <div class="p-1 bg-light">
                        <table class="table table-sm nested-applications-table mb-0">
                          <thead class="thead-light">
                            <tr>
                              <th>User</th>
                              <th class="text-center">Status</th>
                              <th>Applied</th>
                              <th>Sessions / Add-ons</th>
                              <th>Manager</th>
                              <th>Admin</th>
                              <th class="text-center">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-if="!item.applications || !item.applications.length">
                              <td colspan="7" class="text-muted">No applications for this event</td>
                            </tr>
                            <tr v-for="app in item.applications" :key="app.id">
                              <!-- User -->
                              <td style="min-width:150px;">
                                <p class="mb-0 font-weight-600">{{ app.user_name }}</p>
                                <small class="text-muted">{{ app.user_email }}</small>
                              </td>
                              <!-- Status -->
                              <td class="text-center" style="min-width:120px;">
                                <b-badge :variant="getApplicationStatusVariant(app.status)">
                                  {{ getApplicationStatusText(app.status) }}
                                </b-badge>
                              </td>
                              <!-- Applied -->
                              <td>{{ formatDate(app.created_at) }}</td>

                              <!-- Sessions/Add-ons -->
                              <td style="min-width:260px;">
                                <div v-if="app.application_sessions && app.application_sessions.length">
                                  <div v-for="as in app.application_sessions" :key="as.id" class="border rounded p-50 mb-50 bg-white">
                                    <div class="d-flex flex-wrap align-items-center">
                                      <b-badge :variant="as.is_attending ? 'success' : 'secondary'" class="mr-25 mb-25">
                                        {{ as.is_attending ? 'Attending' : 'Not attending' }}
                                      </b-badge>
                                      <span class="mb-25">{{ formatApplicationSession(as) }}</span>
                                    </div>
                                    <div v-if="getAttendingAddonPreferences(as).length" class="mt-25">
                                      <small class="text-muted">Add-ons:</small>
                                      <b-badge
                                        v-for="pref in getAttendingAddonPreferences(as)"
                                        :key="pref.event_session_addon_id"
                                        variant="light-primary"
                                        class="mr-25 mb-25"
                                      >
                                        {{ (pref.addon && (pref.addon.label || pref.addon.code)) || ('#' + pref.event_session_addon_id) }}
                                      </b-badge>
                                    </div>
                                  </div>
                                </div>
                                <span v-else class="text-muted">-</span>
                              </td>

                              <!-- Manager -->
                              <td style="min-width:180px;">
                                <div v-if="app.assigned_manager" class="mb-25">
                                  <small class="text-muted">Assigned:</small><br />
                                  <b-badge variant="primary" class="mr-25 mb-25">{{ app.assigned_manager.name + ' ' + (app.assigned_manager.surname || '') }}</b-badge>
                                </div>
                                <div v-if="app.event_managers && app.event_managers.length">
                                  <small class="text-info font-weight-600">User's Managers:</small><br />
                                  <div class="d-flex flex-wrap">
                                    <b-badge v-for="m in app.event_managers" :key="m.id" variant="info" class="mr-25 mb-25">{{ m.name + ' ' + (m.surname || '') }}</b-badge>
                                  </div>
                                </div>
                                <span v-if="!app.assigned_manager && (!app.event_managers || app.event_managers.length===0)">-</span>
                              </td>
                              <!-- Admin -->
                              <td style="min-width:180px;">
                                <div v-if="app.assigned_admin" class="mb-25">
                                  <small class="text-muted">Assigned:</small><br />
                                  <b-badge variant="success" class="mr-25 mb-25">{{ app.assigned_admin.name + ' ' + (app.assigned_admin.surname || '') }}</b-badge>
                                </div>
                                <div v-if="app.event_admins && app.event_admins.length">
                                  <small class="text-success font-weight-600">Event's Admins:</small><br />
                                  <div class="d-flex flex-wrap">
                                    <b-badge v-for="a in app.event_admins" :key="a.id" variant="success" class="mr-25 mb-25">{{ a.name + ' ' + (a.surname || '') }}</b-badge>
                                  </div>
                                </div>
                                <span v-if="!app.assigned_admin && (!app.event_admins || app.event_admins.length===0)">-</span>
                              </td>
                              <!-- Actions -->
                              <td class="text-center" style="min-width:220px;">
                               <div v-if="canAdminApprove(app) && canUserManageApplication(app)" class="mb-25">
                                  <b-button variant="success" size="sm" class="mr-25" @click.stop="adminApprove(app)"><i class="fa-solid fa-check mr-25"></i>Admin Accept</b-button>
                                  <b-button variant="danger" size="sm" class="mr-25" @click.stop="adminReject(app)"><i class="fa-solid fa-times mr-25"></i>Admin Reject</b-button>
                                  <b-button v-if="app.status !== 'waitlisted'" variant="warning" size="sm" @click.stop="adminWaitlist(app)"><i class="fa-solid fa-clock mr-25"></i>Waitlist</b-button>
                                </div>
                                <div v-else>
                                   <b-button
                                    v-if="app.status === 'pending_manager_approval'"
                                    variant="info"
                                    size="sm"
                                    class="ml-25"
                                    @click="sendReminderToManagers(app)"
                                  >
                                    <i class="fa-solid fa-bell mr-25"></i>Send Reminder to Manager
                                  </b-button> 
                                </div>
                                
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </template>
                  </b-table>
                </div>

                <div class="mx-2 mb-1 mt-1">
                  <b-row>
                    <b-col
                      cols="12"
                      sm="6"
                      class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                      <span class="text-muted">
                        Showing {{ adminEventsDataMeta.from }} to
                        {{ adminEventsDataMeta.to }} of
                        {{ adminEventsDataMeta.of }} entries
                      </span>
                    </b-col>
                    <b-col
                      cols="12"
                      sm="6"
                      class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >
                      <b-pagination
                        v-model="adminEventsCurrentPage"
                        :total-rows="adminEventsTotalRows"
                        :per-page="adminEventsPerPage"
                        first-number
                        last-number
                        class="mb-0 mt-1 mt-sm-0"
                        prev-class="prev-item"
                        next-class="next-item"
                      >
                        <template #prev-text
                          ><feather-icon icon="ChevronLeftIcon" size="18"
                        /></template>
                        <template #next-text
                          ><feather-icon icon="ChevronRightIcon" size="18"
                        /></template>
                      </b-pagination>
                    </b-col>
                  </b-row>
                </div>
              </b-overlay>
            </div>
          </b-card-text>
        </b-tab>

        <!-- Tab 3 - Manager Events -->
        <b-tab title="Manager Events" v-if="canViewApplicationsTab">
          <b-card-text>
            <div>
              <b-overlay :show="managerEventsLoading" rounded="sm" no-fade>
                <b-row class="mb-1">
                  <b-col
                    cols="12"
                    md="7"
                    class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                  >
                    <h3 class="ml-1">Manager Events</h3>
                  </b-col>
                  <b-col
                    cols="12"
                    md="5"
                    class="d-flex align-items-center justify-content-end"
                  >
                    <div class="d-flex align-items-center">
                      <b-form-input
                        v-model="managerEventsFilter"
                        class="d-inline-block mr-1"
                        placeholder="Search..."
                      />
                    </div>
                  </b-col>
                </b-row>

                <div style="max-width: 100%; overflow-x: auto;">
                  <b-table
                    :items="managerFilteredEvents"
                    :fields="managerEventsFields"
                    striped
                    hover
                    small
                    show-empty
                    empty-text="No events found"
                    :filter="managerEventsFilter"
                    @filtered="onManagerEventsFiltered"
                    :current-page="managerEventsCurrentPage"
                    :per-page="managerEventsPerPage"
                    :tbody-tr-class="rowClass"
                  >
                    <!-- Event Title -->
                    <template #cell(course_title)="{ item }">
                      <div style="min-width:220px;">
                        <p class="mb-0 font-weight-600">{{ item.course_title }}</p>
                        <small class="text-muted" v-if="item.title_override">
                          {{ item.title_override }}
                        </small>

                        <div v-if="item && item.is_eft" class="mt-25">
                          <b-badge variant="light-info">Educational Fee Training</b-badge>
                        </div>
                      </div>
                    </template>
                    <!-- Dates -->
                    <template #cell(dates)="{ item }">
                      <div style="min-width:150px;">
                        <div v-if="item.sessions && item.sessions.length">
                          <div v-for="(session, index) in item.sessions" :key="session.id" class="mb-1" style="font-size:0.85em;">
                            <strong>Part {{ index + 1 }}:</strong><br />
                            <span>{{ formatDate(session.start_at) }}</span>
                            <span v-if="session.end_at && session.start_at !== session.end_at"> - {{ formatDate(session.end_at) }}</span>
                          </div>
                        </div>
                        <div v-else-if="item.date_range && (item.date_range.start || item.date_range.end)">
                          <span>{{ formatDate(item.date_range.start) }}</span>
                          <span v-if="item.date_range.end"> - {{ formatDate(item.date_range.end) }}</span>
                        </div>
                        <div v-else>-</div>
                      </div>
                    </template>
                    <!-- Venue -->
                    <template #cell(venue)="{ item }">
                      <div style="min-width:100px;">
                        <div v-if="item.sessions && item.sessions.length">
                          <div v-for="(session, index) in item.sessions" :key="session.id" class="mb-1" style="font-size:0.85em;">
                            <strong>Part {{ index + 1 }}:</strong><br />
                            <span>{{ session.venue || '-' }}</span>
                          </div>
                        </div>
                        <div v-else>
                          <span>{{ (firstSession(item) && firstSession(item).venue) || '-' }}</span>
                        </div>
                      </div>
                    </template>
                    <!-- Time -->
                    <template #cell(time)="{ item }">
                      <div style="min-width:120px;">
                        <div v-if="item.sessions && item.sessions.length">
                          <div v-for="(session, index) in item.sessions" :key="session.id" class="mb-1" style="font-size:0.85em;">
                            <strong>Part {{ index + 1 }}:</strong><br />
                            <span v-if="session.start_at">
                              {{ formatTime(session.start_at) }}
                              <span v-if="session.end_at"> - {{ formatTime(session.end_at) }}</span>
                            </span>
                            <span v-else>-</span>
                          </div>
                        </div>
                        <div v-else>
                          <span v-if="firstSession(item)">{{ formatTime(firstSession(item).start_at) }} - {{ formatTime(firstSession(item).end_at) }}</span>
                          <span v-else>-</span>
                        </div>
                      </div>
                    </template>
                    <!-- Trainer -->
                    <template #cell(trainer)="{ item }">
                      <div style="min-width:100px;">
                        <div v-if="item.sessions && item.sessions.length">
                          <div v-for="(session, index) in item.sessions" :key="session.id" class="mb-1" style="font-size:0.85em;">
                            <strong>Part {{ index + 1 }}:</strong><br />
                            <span>{{ session.trainer || '-' }}</span>
                          </div>
                        </div>
                        <div v-else>
                          <span>{{ (firstSession(item) && firstSession(item).trainer) || '-' }}</span>
                        </div>
                      </div>
                    </template>
                    <!-- Max -->
                    <template #cell(max)="{ item }">
                      <div style="min-width:50px;" class="text-center">
                        <span>{{ item.accepted_count || 0 }}/{{ item.max_participants }}</span>
                      </div>
                    </template>
                    <!-- Event Status -->
                    <template #cell(status)="{ item }">
                      <b-badge :variant="statusVariant(item.status)">{{ item.status }}</b-badge>
                    </template>
                    <!-- Applications Count -->
                    <template #cell(applications_count)="{ item }">
                      {{ item.applications ? item.applications.length : 0 }}
                    </template>
                    <!-- Toggle Details Button -->
                    <template #cell(_details)="row">
                      <b-button size="sm" variant="outline-primary" @click="row.toggleDetails" :title="row.detailsShowing ? 'Hide Applications' : 'Show Applications'">
                        <feather-icon :icon="row.detailsShowing ? 'ChevronUpIcon' : 'ChevronDownIcon'" size="16" class="mr-25" />
                        {{ row.detailsShowing ? 'Hide' : 'View' }}
                      </b-button>
                    </template>
                    <!-- Row Details: Nested Applications Table (plain HTML table) -->
                    <template #row-details="{ item }">
                      <div class="p-1 bg-light">
                        <table class="table table-sm nested-applications-table mb-0">
                          <thead class="thead-light">
                            <tr>
                              <th style="background-color: lightgray;">User</th>
                              <th class="text-center" style="background-color: lightgray;">Status</th>
                              <th style="background-color: lightgray;">Applied</th>
                              <th style="background-color: lightgray;">Sessions / Add-ons</th>
                              <th style="background-color: lightgray;">Manager</th>
                              <th style="background-color: lightgray;">Admin</th>
                              <th class="text-center" style="background-color: lightgray;">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-if="!item.applications || !item.applications.length">
                              <td colspan="7" class="text-muted">No applications for this event</td>
                            </tr>
                            <tr v-for="app in item.applications" :key="app.id">
                              <!-- User -->
                              <td style="min-width:150px;">
                                <p class="mb-0 font-weight-600">{{ app.user_name }}</p>
                                <small class="text-muted">{{ app.user_email }}</small>
                              </td>
                              <!-- Status -->
                              <td class="text-center" style="min-width:120px;">
                                <b-badge :variant="getApplicationStatusVariant(app.status)">
                                  {{ getApplicationStatusText(app.status) }}
                                </b-badge>
                              </td>
                              <!-- Applied -->
                              <td>{{ formatDate(app.created_at) }}</td>

                              <!-- Sessions/Add-ons -->
                              <td style="min-width:260px;">
                                <div v-if="app.application_sessions && app.application_sessions.length">
                                  <div v-for="as in app.application_sessions" :key="as.id" class="border rounded p-50 mb-50 bg-white">
                                    <div class="d-flex flex-wrap align-items-center">
                                      <b-badge :variant="as.is_attending ? 'success' : 'secondary'" class="mr-25 mb-25">
                                        {{ as.is_attending ? 'Attending' : 'Not attending' }}
                                      </b-badge>
                                      <span class="mb-25">{{ formatApplicationSession(as) }}</span>
                                    </div>
                                    <div v-if="getAttendingAddonPreferences(as).length" class="mt-25">
                                      <small class="text-muted">Add-ons:</small>
                                      <b-badge
                                        v-for="pref in getAttendingAddonPreferences(as)"
                                        :key="pref.event_session_addon_id"
                                        variant="light-primary"
                                        class="mr-25 mb-25"
                                      >
                                        {{ (pref.addon && (pref.addon.label || pref.addon.code)) || ('#' + pref.event_session_addon_id) }}
                                      </b-badge>
                                    </div>
                                  </div>
                                </div>
                                <span v-else class="text-muted">-</span>
                              </td>

                              <!-- Manager -->
                              <td style="min-width:180px;">
                                <div v-if="app.assigned_manager" class="mb-25">
                                  <small class="text-muted">Assigned:</small><br />
                                  <b-badge variant="primary" class="mr-25 mb-25">{{ app.assigned_manager.name + ' ' + (app.assigned_manager.surname || '') }}</b-badge>
                                </div>
                                <div v-if="app.event_managers && app.event_managers.length">
                                  <small class="text-info font-weight-600">User's Managers:</small><br />
                                  <div class="d-flex flex-wrap">
                                    <b-badge v-for="m in app.event_managers" :key="m.id" variant="info" class="mr-25 mb-25">{{ m.name + ' ' + (m.surname || '') }}</b-badge>
                                  </div>
                                </div>
                                <span v-if="!app.assigned_manager && (!app.event_managers || app.event_managers.length===0)">-</span>
                              </td>
                              <!-- Admin -->
                              <td style="min-width:180px;">
                                <div v-if="app.assigned_admin" class="mb-25">
                                  <small class="text-muted">Assigned:</small><br />
                                  <b-badge variant="success" class="mr-25 mb-25">{{ app.assigned_admin.name + ' ' + (app.assigned_admin.surname || '') }}</b-badge>
                                </div>
                                <div v-if="app.event_admins && app.event_admins.length">
                                  <small class="text-success font-weight-600">Event's Admins:</small><br />
                                  <div class="d-flex flex-wrap">
                                    <b-badge v-for="a in app.event_admins" :key="a.id" variant="success" class="mr-25 mb-25">{{ a.name + ' ' + (a.surname || '') }}</b-badge>
                                  </div>
                                </div>
                                <span v-if="!app.assigned_admin && (!app.event_admins || app.event_admins.length===0)">-</span>
                              </td>
                              <!-- Actions -->
                              <td class="text-center" style="min-width:220px;">
                                <div v-if="canManagerApprove(app) && isUserDepartmentManager(app)" class="mb-25">
                                  <b-button variant="success" size="sm" class="mr-25" @click.stop="managerApprove(app)"><i class="fa-solid fa-check mr-25"></i>Manager Approve</b-button>
                                  <b-button variant="danger" size="sm" @click.stop="managerReject(app)"><i class="fa-solid fa-times mr-25"></i>Manager Reject</b-button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </template>
                  </b-table>
                </div>

                <div class="mx-2 mb-1 mt-1">
                  <b-row>
                    <b-col
                      cols="12"
                      sm="6"
                      class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                      <span class="text-muted">
                        Showing {{ managerEventsDataMeta.from }} to
                        {{ managerEventsDataMeta.to }} of
                        {{ managerEventsDataMeta.of }} entries
                      </span>
                    </b-col>
                    <b-col
                      cols="12"
                      sm="6"
                      class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >
                      <b-pagination
                        v-model="managerEventsCurrentPage"
                        :total-rows="managerEventsTotalRows"
                        :per-page="managerEventsPerPage"
                        first-number
                        last-number
                        class="mb-0 mt-1 mt-sm-0"
                        prev-class="prev-item"
                        next-class="next-item"
                      >
                        <template #prev-text
                          ><feather-icon icon="ChevronLeftIcon" size="18"
                        /></template>
                        <template #next-text
                          ><feather-icon icon="ChevronRightIcon" size="18"
                        /></template>
                      </b-pagination>
                    </b-col>
                  </b-row>
                </div>
              </b-overlay>
            </div>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>

    <!-- Apply Modal -->
    <b-modal
      v-model="showApplyModal"      :title="
        getApplicationMethodInfo
          ? getApplicationMethodInfo.title
          : 'Apply to Event'
      "
      @hidden="resetApplyForm"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div v-if="selectedEvent && getApplicationMethodInfo">
       
        <h6 class="mb-1">
          {{
            selectedEvent.course_title ||
              (selectedEvent.course && selectedEvent.course.title)
          }}
        </h6>
        <p v-if="selectedEvent.title_override" class="text-muted mb-2">
          {{ selectedEvent.title_override }}
        </p>

        <b-form @submit.prevent="handleApplySubmit">
          <b-form-group
            :label="getApplicationMethodInfo.label"
            label-for="apply-input"
          >
            <!-- Email input -->
            <b-form-input
              v-if="getApplicationMethodInfo.inputType === 'email'"
              id="apply-input"
              v-model="applyForm.reason"
              type="email"
              :placeholder="getApplicationMethodInfo.placeholder"
              pattern="[^\s@]+@[^\s@]+\.[^\s@]+"
              title="Please enter a valid email address"
              required
              :disabled="applyLoading"
            />

            <!-- URL input -->
            <b-form-input
              v-else-if="getApplicationMethodInfo.inputType === 'url'"
              id="apply-input"
              v-model="applyForm.reason"
              type="url"
              :placeholder="getApplicationMethodInfo.placeholder"
              pattern="https?://.+|www\..+|.+\..+"
              title="Please enter a valid website URL"
              required
              :disabled="applyLoading"
            />

            <!-- Textarea -->
            <b-form-textarea
              v-else
              id="apply-input"
              v-model="applyForm.reason"
              rows="4"
              :placeholder="getApplicationMethodInfo.placeholder"
              required
              :disabled="applyLoading"
            />
          </b-form-group>

          <!-- Special Needs (optional) -->
          <b-form-group
            label="Please state any special needs. (including food allergies)"
            label-for="special-needs-input"
          >
            <b-form-textarea
              id="special-needs-input"
              v-model="applyForm.special_needs"
              rows="3"
              :disabled="applyLoading"
            />
          </b-form-group>

          <div
            v-if="selectedEvent && selectedEvent.sessions && selectedEvent.sessions.length && !selectedEvent.is_eft"
            class="mb-1"
          >
            <h6 class="mb-50">Session selection</h6>
            <div
              v-for="s in sortedApplySessions"
              :key="s.id"
              v-if="applySessionSelections[s.id]"
              class="border rounded p-75 mb-50"
            >
              <b-form-checkbox
                v-model="applySessionSelections[s.id].is_attending"
                :disabled="applyLoading"
                @change="() => onApplySessionToggle(s)"
              >
                Attend session {{ s.sequence_no || '' }}
                <span class="text-muted" v-if="s.start_at && s.end_at">
                  ({{ formatSessionRange(s) }})
                </span>
              </b-form-checkbox>

              <div v-if="getApplySessionAddons(s).length" class="mt-50 ml-2">
                <p class="mb-25 text-muted small">Add-ons</p>
                <div v-for="a in getApplySessionAddons(s)" :key="a.id" class="mb-25">
                  <b-form-checkbox
                    :checked="getApplyAddonChecked(s.id, a)"
                    :disabled="applyLoading || !applySessionSelections[s.id].is_attending || !!(a.is_required || a.required)"
                    @change="(val) => setApplyAddonChecked(s.id, a, val)"
                  >
                    {{ a.label || a.code }}
                    <b-badge v-if="a.is_required || a.required" variant="light-primary" class="ml-25">Required</b-badge>
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-end">
            <b-button
              variant="secondary"
              class="mr-2"
              @click="cancelApplication"
              :disabled="applyLoading"
            >
              Cancel
            </b-button>
            <b-button type="submit" variant="primary" :disabled="applyLoading">
              <b-spinner v-if="applyLoading" small class="mr-1" />
              {{ applyLoading ? "Applying..." : "OK" }}
            </b-button>
          </div>
        </b-form>
      </div>
    </b-modal>

    <!-- Special Needs Modal -->
    <b-modal
      v-model="showSpecialNeedsModal"
      title="Special Needs"
      ok-title="Save"
      cancel-title="Cancel"
      :ok-disabled="specialNeedsLoading"
      :cancel-disabled="specialNeedsLoading"
      @ok.prevent="saveSpecialNeeds"
      @hidden="specialNeedsText = ''; specialNeedsEventId = null"
    >
      <b-form-group
        label="Please state any special needs (including food allergies)"
        label-for="special-needs-modal-input"
      >
        <b-form-textarea
          id="special-needs-modal-input"
          v-model="specialNeedsText"
          rows="5"
          maxlength="2000"
          placeholder="Enter your special needs here..."
          :disabled="specialNeedsLoading"
        />
        <small class="text-muted">{{ specialNeedsText.length }}/2000</small>
      </b-form-group>
      <b-spinner v-if="specialNeedsLoading" small class="mr-1" />
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BTabs,
  BTab,
  BButton,
  BOverlay,
  BFormInput,
  BFormCheckbox,
  BTable,
  BBadge,
  BPagination,
  BModal,
  BFormGroup,
  BFormTextarea,
  BAlert,
  BForm,
  BSpinner,
} from "bootstrap-vue";
import store from "@/store";
import { onUnmounted } from "@vue/composition-api";
import eventsStoreModule from "@/views/events/eventsStoreModule";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  name: "Dashboard",
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BTabs,
    BTab,
    BButton,
    BOverlay,
    BFormInput,
    BFormCheckbox,
    BTable,
    BBadge,
    BPagination,
    BModal,
    BFormGroup,
    BFormTextarea,
    BAlert,
    BForm,
    BSpinner,
    ToastificationContent,
  },
  data() {
    return {
      // Events data
      eventsLoading: false,
      eventsItems: [],
      eventsFilter: null,
      eventsCurrentPage: 1,
      eventsPerPage: 10,
      eventsTotalRows: 0,
      // Passed events data
      passedEventsLoading: false,
      passedEventsItems: [],
      passedEventsFilter: null,
      passedEventsCurrentPage: 1,
      passedEventsPerPage: 10,
      passedEventsTotalRows: 0,
      // Admin-managed events data
      adminEventsLoading: false,
      adminEventsItems: [],
      adminEventsFilter: null,
      adminEventsCurrentPage: 1,
      adminEventsPerPage: 10,
      adminEventsTotalRows: 0,
      // Manager events data
      managerEventsLoading: false,
      managerEventsItems: [],
      managerEventsFilter: null,
      managerEventsCurrentPage: 1,
      managerEventsPerPage: 10,
      managerEventsTotalRows: 0,
      // User applications data
      userApplications: [],
      isEventAdmin: false, // Event admin status'u
      // All applications data
      applicationsLoading: false,
      applicationsYear: new Date().getFullYear(),
      applicationsItems: [],
      applicationsFilter: null,
      applicationsCurrentPage: 1,
      applicationsPerPage: 10,
      applicationsTotalRows: 0,
      applicationsFields: [
        { key: "course_title", label: "Event", thStyle: "color:white!important" },
        { key: "dates", label: "Date(s)", thStyle: "color:white!important" },
        { key: "venue", label: "Venue", thStyle: "color:white!important" },
        { key: "time", label: "Time", thStyle: "color:white!important" },
        { key: "trainer", label: "Trainer", thStyle: "color:white!important" },
        { key: "max", label: "Max", thStyle: "color:white!important", class: "text-center" },
        { key: "event_status", label: "Event Status", thStyle: "color:white!important", class: "text-center" },
        { key: "applications_count", label: "Applications", thStyle: "color:white!important", class: "text-center" },
        { key: "_details", label: "Details", thStyle: "color:white!important" },
      ],
      nestedApplicationFields: [
        { key: "user_name", label: "User" },
        { key: "status", label: "Status" },
        { key: "created_at", label: "Applied" },
        { key: "assigned_manager", label: "Manager" },
        { key: "assigned_admin", label: "Admin" },
        { key: "actions", label: "Actions" },
      ],
      // Apply Modal
      showApplyModal: false,
      selectedEvent: null,
      applyForm: {
        reason: "",
        special_needs: "",
      },
      applySessionSelections: {},
      applyLoading: false,
      // Special Needs Modal
      showSpecialNeedsModal: false,
      specialNeedsEventId: null,
      specialNeedsText: "",
      specialNeedsLoading: false,
    };
  },
  setup() {
    const MODULE = "events";
    if (!store.hasModule(MODULE))
      store.registerModule(MODULE, eventsStoreModule);
    onUnmounted(() => {
      if (store.hasModule(MODULE)) store.unregisterModule(MODULE);
    });
  },
  async created() {
    // Event admin status'unu kontrol et
    await this.checkEventAdminStatus();

    this.loadActiveEvents();
    this.loadPassedEvents();

    // User applications sadece Events tab için gerekli
    this.loadUserApplications();

    // Applications tab'ını görebilen kullanıcılar için all-applications yükle
    if (this.canViewApplicationsTab) {
      this.loadAdminEvents();
      this.loadManagerEvents();
    }
  },
  computed: {
    passedEventsDataMeta() {
      return {
        from: this.passedEventsTotalRows
          ? this.passedEventsPerPage * (this.passedEventsCurrentPage - 1) + 1
          : 0,
        to: Math.min(
          this.passedEventsPerPage * (this.passedEventsCurrentPage - 1) +
            this.passedEventsPerPage,
          this.passedEventsTotalRows
        ),
        of: this.passedEventsTotalRows,
      };
    },
    adminEventsDataMeta() {
      return {
        from: this.adminEventsTotalRows
          ? this.adminEventsPerPage * (this.adminEventsCurrentPage - 1) + 1
          : 0,
        to: Math.min(
          this.adminEventsPerPage * (this.adminEventsCurrentPage - 1) +
            this.adminEventsPerPage,
          this.adminEventsTotalRows
        ),
        of: this.adminEventsTotalRows,
      };
    },
    eventsDataMeta() {
      return {
        from: this.eventsTotalRows
          ? this.eventsPerPage * (this.eventsCurrentPage - 1) + 1
          : 0,
        to: Math.min(
          this.eventsPerPage * (this.eventsCurrentPage - 1) +
            this.eventsPerPage,
          this.eventsTotalRows
        ),
        of: this.eventsTotalRows,
      };
    },
    adminFilteredEvents() {
      if (!this.adminEventsFilter) return this.adminEventsItems;
      const t = this.adminEventsFilter.toLowerCase();
      return this.adminEventsItems.filter(
        (i) =>
          (i.course_title || (i.course && i.course.title) || "")
            .toLowerCase()
            .includes(t) || (i.aim || "").toLowerCase().includes(t)
      );
    },
    filteredEvents() {
      // Backend zaten sadece open eventleri gönderiyor
      if (!this.eventsFilter) return this.eventsItems;
      const t = this.eventsFilter.toLowerCase();
      return this.eventsItems.filter(
        (i) =>
          (i.course_title || (i.course && i.course.title) || "")
            .toLowerCase()
            .includes(t) || (i.aim || "").toLowerCase().includes(t)
      );
    },
    filteredPassedEvents() {
      if (!this.passedEventsFilter) return this.passedEventsItems;
      const t = this.passedEventsFilter.toLowerCase();
      return this.passedEventsItems.filter(
        (i) =>
          (i.course_title || (i.course && i.course.title) || "")
            .toLowerCase()
            .includes(t) || (i.aim || "").toLowerCase().includes(t)
      );
    },
    adminEventsFields() {
      // Full event columns for Manager Events + details
      return [
        { key: "course_title", label: "Course", thStyle: "color:white!important" },
        { key: "dates", label: "Date(s)", thStyle: "color:white!important" },
        { key: "venue", label: "Venue", thStyle: "color:white!important" },
        { key: "time", label: "Time", thStyle: "color:white!important" },
        { key: "trainer", label: "Trainer", thStyle: "color:white!important" },
        { key: "max", label: "Max", class: "text-center", thStyle: "color:white!important" },
        { key: "status", label: "Event Status", class: "text-center", thStyle: "color:white!important" },
        { key: "applications_count", label: "Applications", class: "text-center", thStyle: "color:white!important" },
        { key: "_details", label: "Details", thStyle: "color:white!important" },
      ];
    },
    managerEventsDataMeta() {
      return {
        from: this.managerEventsTotalRows
          ? this.managerEventsPerPage * (this.managerEventsCurrentPage - 1) + 1
          : 0,
        to: Math.min(
          this.managerEventsPerPage * (this.managerEventsCurrentPage - 1) +
            this.managerEventsPerPage,
          this.managerEventsTotalRows
        ),
        of: this.managerEventsTotalRows,
      };
    },
    managerFilteredEvents() {
      if (!this.managerEventsFilter) return this.managerEventsItems;
      const t = this.managerEventsFilter.toLowerCase();
      return this.managerEventsItems.filter(
        (i) =>
          (i.course_title || (i.course && i.course.title) || "")
            .toLowerCase()
            .includes(t) || (i.aim || "").toLowerCase().includes(t)
      );
    },
    managerEventsFields() {
      return [
        { key: "course_title", label: "Course", thStyle: "color:white!important" },
        { key: "dates", label: "Date(s)", thStyle: "color:white!important" },
        { key: "venue", label: "Venue", thStyle: "color:white!important" },
        { key: "time", label: "Time", thStyle: "color:white!important" },
        { key: "trainer", label: "Trainer", thStyle: "color:white!important" },
        { key: "max", label: "Max", class: "text-center", thStyle: "color:white!important" },
        { key: "status", label: "Event Status", class: "text-center", thStyle: "color:white!important" },
        { key: "applications_count", label: "Applications", class: "text-center", thStyle: "color:white!important" },
        { key: "_details", label: "Details", thStyle: "color:white!important" },
      ];
    },
    applicationsDataMeta() {
      return {
        from: this.applicationsTotalRows
          ? this.applicationsPerPage * (this.applicationsCurrentPage - 1) + 1
          : 0,
        to: Math.min(
          this.applicationsPerPage * (this.applicationsCurrentPage - 1) +
            this.applicationsPerPage,
          this.applicationsTotalRows
        ),
        of: this.applicationsTotalRows,
      };
    },
    canViewApplicationsTab() {
      // Development Manager, Admin, Supermanager rollerini kontrol et
      const userData = JSON.parse(localStorage.getItem("userData")) || {};
      const userRole = userData.role || "";

      const allowedRoles = [
        "Development Manager",
        "admin",
        "supermanager",
        "Administrator",
        "Regional Manager",
      ];

      // Sistem admin'i veya Development Manager ise true
      if (allowedRoles.includes(userRole)) {
        return true;
      }

      // Event admin kontrolü - backend'den aldığımız status'u kullan
      return this.isEventAdmin;
    },
    eventsFields() {
      const userData = JSON.parse(localStorage.getItem("userData")) || {};
      const userRole = userData.role || "";
      const isManagerOrAdmin = [
        "admin",
        "supermanager",
        "Administrator",
      ].includes(userRole);

      let fields = [
        { key: "course", label: "Course", thStyle: "color:white!important" },
        { key: "dates", label: "Date(s)", thStyle: "color:white!important" },
        { key: "venue", label: "Venue", thStyle: "color:white!important" },
        { key: "time", label: "Time", thStyle: "color:white!important" },
        { key: "trainer", label: "Trainer", thStyle: "color:white!important" },
        {
          key: "max",
          label: "Max",
          class: "text-center",
          thStyle: "color:white!important",
        },
        {
          key: "status",
          label: "Event Status",
          class: "text-center",
          thStyle: "color:white!important",
        },
      ];

      // Manager/Admin değilse My Status kolonunu ekle
      if (!isManagerOrAdmin) {
        fields.push({
          key: "my_status",
          label: "My Status",
          class: "text-center",
          thStyle: "color:white!important",
        });
      }

      // Actions kolonunu ekle
      fields.push({
        key: "actions",
        label: "Actions",
        class: "text-center",
        thStyle: "color:white!important",
      });

      return fields;
    },
    getApplicationMethodInfo() {
      if (!this.selectedEvent) return null;

      const isWaitlist = this.isEventFull(this.selectedEvent);

      return {
        title: isWaitlist ? "Join Waitlist" : "Apply to Event",
        label: "Why do you want to participate in this event? *",
        placeholder:
          "Please explain why you want to participate in this event...",
        inputType: "textarea",
        showTextarea: true,
      };
    },

    sortedApplySessions() {
      const sessions = this.selectedEvent && Array.isArray(this.selectedEvent.sessions)
        ? this.selectedEvent.sessions
        : [];
      return sessions.slice().sort((a, b) => (a.sequence_no || 0) - (b.sequence_no || 0));
    },

  },
  methods: {
    rowClass(item, type) {
      if (type !== 'row' || !item) return '';
      return item.is_eft ? 'eft-row' : '';
    },
    loadAdminEvents() {
      // Preserve which rows had details expanded
      const expandedIds = (this.adminEventsItems || [])
        .filter((item) => item._showDetails)
        .map((item) => item.id);

      this.adminEventsLoading = true;
      this.$http
        .get(`/dashboard/user-admin-events`)
        .then((res) => {
          this.adminEventsItems = res.data;
          this.adminEventsTotalRows = this.adminEventsItems.length;

          // Restore expanded state
          if (expandedIds.length) {
            this.adminEventsItems.forEach((item) => {
              if (expandedIds.includes(item.id)) {
                this.$set(item, '_showDetails', true);
              }
            });
          }
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Failed to load managed events",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.adminEventsLoading = false;
        });
    },
    onAdminEventsFiltered(items) {
      this.adminEventsTotalRows = items.length;
      this.adminEventsCurrentPage = 1;
    },
    loadManagerEvents() {
      // Preserve which rows had details expanded
      const expandedIds = (this.managerEventsItems || [])
        .filter((item) => item._showDetails)
        .map((item) => item.id);

      this.managerEventsLoading = true;
      this.$http
        .get(`/dashboard/user-manager-events`)
        .then((res) => {
          this.managerEventsItems = res.data;
          this.managerEventsTotalRows = this.managerEventsItems.length;

          // Restore expanded state
          if (expandedIds.length) {
            this.managerEventsItems.forEach((item) => {
              if (expandedIds.includes(item.id)) {
                this.$set(item, '_showDetails', true);
              }
            });
          }
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Failed to load manager events",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.managerEventsLoading = false;
        });
    },
    onManagerEventsFiltered(items) {
      this.managerEventsTotalRows = items.length;
      this.managerEventsCurrentPage = 1;
    },
    async checkEventAdminStatus() {
      try {
        const res = await this.$http.get("/dashboard/check-event-admin");
        this.isEventAdmin = res.data.is_event_admin;
        console.log("Event admin status:", this.isEventAdmin);
      } catch (e) {
        console.error("Failed to check event admin status:", e);
        this.isEventAdmin = false;
      }
    },
    loadActiveEvents() {
      this.eventsLoading = true;
      this.$http
        .get(`events/active`)
        .then((res) => {
          this.eventsItems = res.data;
          this.eventsTotalRows = this.eventsItems.length;
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Failed to load events",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.eventsLoading = false;
        });
    },
    loadPassedEvents() {
      this.passedEventsLoading = true;
      this.$http
        .get(`events/passed`)
        .then((res) => {
          this.passedEventsItems = res.data;
          this.passedEventsTotalRows = this.passedEventsItems.length;
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Failed to load passed events",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.passedEventsLoading = false;
        });
    },
    loadApplicationsByYear() {
      this.applicationsLoading = true;
      store
        .dispatch("events/getAllApplications", { year: this.applicationsYear })
        .then((res) => {
          // Expecting grouped format: [{ event_id, event_title, event_status, event_description, applications: [] }]
          this.applicationsItems = Array.isArray(res.data)
            ? res.data.map(ev => ({ ...ev, _showDetails: true }))
            : [];
          this.applicationsTotalRows = this.applicationsItems.length; // rows = events
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Failed to load applications",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.applicationsLoading = false;
        });
    },
    onApplicationsFiltered(items) {
      this.applicationsTotalRows = items.length;
      this.applicationsCurrentPage = 1;
    },
    viewApplication(id) {
      this.$router.push({ name: "event-applications-view", params: { id } });
    },
    viewEvent(id) {
      this.$router.push({ name: "dashboard-event-view", params: { id }, query: { from: 'dashboard' } });
    },
    // Manager approval methods
    canManagerApprove(item) {
      // Manager: pending_manager_approval durumunda ve assigned_manager_id null ise onaylayabilir
      // Ayrıca bu user'ın manager'larından biri kendisi olmalı
      const userData = JSON.parse(localStorage.getItem("userData")) || {};
      const currentUserId = userData.id;

      // Current user'ın bu user'ın manager'ları arasında olup olmadığını kontrol et
      const isUserManager =
        item.event_managers &&
        item.event_managers.some((manager) => manager.id === currentUserId);

      const canApprove =
        item.status === "pending_manager_approval" &&
        !item.assigned_manager &&
        isUserManager;

      return canApprove;
    },
    async managerApprove(item) {
      try {
        this.managerEventsLoading = true;
        await store.dispatch("events/managerApproveApplication", {
          applicationId: item.id,
        });

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Application Approved",
            text: "Application has been approved",
            icon: "CheckIcon",
            variant: "success",
          },
        });

        // Refresh manager events
        await this.loadManagerEvents();
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            text: e.response?.data?.message || "Failed to approve application",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.managerEventsLoading = false;
      }
    },
    async managerReject(item) {
      try {
        // Onay modalı göster
        const result = await this.$swal({
          title: "Are you sure?",
          text: "Do you want to reject this application as a manager?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Yes, reject it!",
          cancelButtonText: "Cancel",
          customClass: {
            confirmButton: "btn btn-danger",
            cancelButton: "btn btn-secondary ml-1",
          },
          buttonsStyling: false,
        });

        if (result.isConfirmed) {
          this.managerEventsLoading = true;
          await store.dispatch("events/managerRejectApplication", {
            applicationId: item.id,
          });

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Application Rejected",
              text: "Application has been rejected by manager.",
              icon: "XIcon",
              variant: "warning",
            },
          });

          // Refresh manager events
          await this.loadManagerEvents();
        }
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            text: e.response?.data?.message || "Failed to reject application",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.managerEventsLoading = false;
      }
    },

    canUserManageApplication(item) {
      const userData = JSON.parse(localStorage.getItem("userData")) || {};
      const userRole = userData.role || "";
      const currentUserId = userData.id;

      // System admin or supermanager can manage all applications
      if (["admin", "supermanager", "Administrator"].includes(userRole)) {
        return true;
      }

      // Event admin can manage applications for events they are assigned to
      if (
        item.event_admins &&
        item.event_admins.some((admin) => admin.id === currentUserId)
      ) {
        return true;
      }

      return false;
    },

    // Admin approval methods
    canAdminApprove(item) {
      // Admin: pending_admin_review, pending_manager_approval veya waitlisted durumunda onaylayabilir
      // Admin'ler manager yerine de onay yapabilir, waitlisted'den de accept edebilir
      // Waitlisted durumunda assigned_admin kontrolü yapılmaz çünkü zaten admin atanmış olabilir
      if (item.status === "waitlisted") {
        return true;
      }

      const canApprove =
        (item.status === "pending_admin_review" ||
          item.status === "pending_manager_approval") &&
        !item.assigned_admin;
      return canApprove;
    },
    async adminApprove(item) {
      try {
        this.adminEventsLoading = true;
        await store.dispatch("events/adminAcceptApplication", {
          applicationId: item.id,
        });

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Application Accepted",
            text: "Application has been accepted.",
            icon: "CheckIcon",
            variant: "success",
          },
        });

        // Refresh admin events
        await this.loadAdminEvents();
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            text: e.response?.data?.message || "Failed to accept application",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.adminEventsLoading = false;
      }
    },
    async adminReject(item) {
      // Confirmation modal
      const result = await this.$swal({
        title: "Reject Application?",
        text: "Are you sure you want to reject this application?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Reject",
        cancelButtonText: "No, Cancel",
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-outline-secondary ml-1",
        },
        buttonsStyling: false,
      });

      if (!result.isConfirmed) {
        return; // User cancelled
      }

      try {
        this.adminEventsLoading = true;
        await store.dispatch("events/adminRejectApplication", {
          applicationId: item.id,
        });

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Application Rejected",
            text: "Application has been rejected.",
            icon: "XIcon",
            variant: "warning",
          },
        });

        // Refresh admin events
        await this.loadAdminEvents();
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            text: e.response?.data?.message || "Failed to reject application",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.adminEventsLoading = false;
      }
    },
    async adminWaitlist(item) {
      try {
        this.adminEventsLoading = true;
        await store.dispatch("events/adminWaitlistApplication", {
          applicationId: item.id,
        });

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Application Waitlisted",
            text: "Application has been added to waitlist.",
            icon: "ClockIcon",
            variant: "info",
          },
        });

        // Refresh admin events
        await this.loadAdminEvents();
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            text: e.response?.data?.message || "Failed to waitlist application",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.adminEventsLoading = false;
      }
    },
    firstSession(item) {
      return (item.sessions && item.sessions[0]) || null;
    },
    statusVariant(s) {
      return s === "open"
        ? "light-success"
        : s === "closed"
        ? "light-secondary"
        : s === "cancelled"
        ? "light-danger"
        : "light-warning";
    },
    onEventsFiltered(items) {
      this.eventsTotalRows = items.length;
      this.eventsCurrentPage = 1;
    },
    onPassedEventsFiltered(items) {
      this.passedEventsTotalRows = items.length;
      this.passedEventsCurrentPage = 1;
    },
    formatDate(val) {
      if (!val) return "-";
      const date = new Date(val);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
    formatTime(val) {
      if (!val) return "-";
      const d = new Date(val);
      return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    },
    async loadUserApplications() {
      try {
        const res = await store.dispatch("events/getUserApplications");
        this.userApplications = res.data || [];
      } catch (e) {
        console.error("Failed to load user applications:", e);
      }
    },
    getUserApplication(eventId) {
      return this.userApplications.find((app) => app.event_id === eventId);
    },
    getMyStatusVariant(item) {
      const application = this.getUserApplication(item.id);
      if (!application) return "dark";

      switch (application.status) {
        case "accepted":
          return "success";
        case "rejected":
        case "manager_rejected":
          return "danger";
        case "pending_manager_approval":
          return "warning";
        case "pending_admin_review":
          return "info";
        case "waitlisted":
          return "secondary";
        case "withdrawn":
        case "cancelled":
        case "draft":
          return "dark";
        case "submitted":
          return "primary";
        default:
          return "dark";
      }
    },
    getMyStatusText(item) {
      const application = this.getUserApplication(item.id);
      if (!application) return "No Application Submitted";

      switch (application.status) {
        case "accepted":
          return "Placed";
        case "rejected":
        case "manager_rejected":
          return "Not Approved";
        case "pending_manager_approval":
        case "pending_admin_review":
        case "submitted":
          return "Pending Approval";
        case "waitlisted":
          return "Waiting Listed";
        case "withdrawn":
        case "cancelled":
        case "draft":
        default:
          return "No Application Submitted";
      }
    },
    canWithdraw(application) {
      if (!application) return false;
      // Kullanıcı withdrawn, cancelled, accepted, rejected, manager_rejected olmayan başvurularını geri çekebilir
      return ![
        "withdrawn",
        "cancelled",
        "accepted",
        "rejected",
        "manager_rejected",
      ].includes(application.status);
    },
    getApplicationStatusVariant(status) {
      switch (status) {
        case "accepted":
          return "success";
        case "rejected":
        case "manager_rejected":
          return "danger";
        case "pending_manager_approval":
          return "warning";
        case "pending_admin_review":
          return "info";
        case "waitlisted":
          return "secondary";
        case "withdrawn":
        case "cancelled":
          return "light";
        case "draft":
        case "submitted":
          return "primary";
        default:
          return "secondary";
      }
    },
    getApplicationStatusText(status) {
      switch (status) {
        case "draft":
          return "Draft";
        case "submitted":
          return "Submitted";
        case "pending_manager_approval":
          return "Pending Manager Approval";
        case "manager_rejected":
          return "Manager Rejected";
        case "pending_admin_review":
          return "Under Admin Review";
        case "waitlisted":
          return "Waitlisted";
        case "accepted":
          return "Accepted";
        case "rejected":
          return "Rejected";
        case "withdrawn":
          return "Withdrawn";
        case "cancelled":
          return "Cancelled";
        default:
          return status;
      }
    },
    async withdrawFromEvent(item) {
      try {
        this.eventsLoading = true;
        const application = this.getUserApplication(item.id);
        if (!application) return;

        await store.dispatch("events/withdrawApplication", {
          applicationId: application.id,
        });

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Application Withdrawn",
            text:
              "Your application has been successfully withdrawn. You can apply again if you wish.",
            icon: "CheckIcon",
            variant: "success",
          },
        });

        // Refresh applications and events
        await this.loadUserApplications();
        await this.loadActiveEvents();
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            text: e.response?.data?.message || "Withdraw failed",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.eventsLoading = false;
      }
    },
    // Role check methods
    isUserDepartmentManager(item) {
      const userData = JSON.parse(localStorage.getItem("userData")) || {};
      const userId = userData.id;

      if (item.event_managers && item.event_managers.length > 0 && userId) {
        return item.event_managers.some((manager) => manager.id === userId);
      }


      return false;
    },
    isUserAdmin() {
      const userData = JSON.parse(localStorage.getItem("userData")) || {};
      const isAdmin = ["admin", "supermanager", "Administrator"].includes(
        userData.role
      );
      console.log("isUserAdmin check:", userData.role, isAdmin);
      return isAdmin;
    },
    canUserManageApplication(item) {
      const userData = JSON.parse(localStorage.getItem("userData")) || {};
      const userRole = userData.role || "";
      const userId = userData.id;

      // Sistem admin'i ise her şeyi yönetebilir
      // if (["admin", "supermanager", "Administrator"].includes(userRole)) {
      //   return true;
      // }
       // Event admin kontrolü - bu application'ın event'inin admin'i mi?
      if (item.event_managers && item.event_managers.length > 0 && userId) {
        return item.event_managers.some((manager) => manager.id === userId);
      }


      // Event admin kontrolü - bu application'ın event'inin admin'i mi?
      if (item.event_admins && item.event_admins.length > 0 && userId) {
        return item.event_admins.some((admin) => admin.id === userId);
      }

      return false;
    },
    isManagerOrAdmin() {
      const userData = JSON.parse(localStorage.getItem("userData")) || {};
      const userRole = userData.role || "";
      // Department Manager'ı kaldırdık - sadece gerçek admin roller
      return ["admin", "supermanager", "Administrator"].includes(userRole);
    },
    canApplyToEvent() {
      // Sadece normal kullanıcılar apply edebilir (admin/manager değil)
      const userData = JSON.parse(localStorage.getItem("userData")) || {};
      let userPerms = JSON.parse(localStorage.getItem("userPerms")) || [];

      // userPerms'in array olduğundan emin olalım
      if (!Array.isArray(userPerms)) {
        userPerms = [];
      }

      // Admin/manager ise apply edemez
      // if (this.isManagerOrAdmin()) {
      //   return false;
      // }

      // Department Manager rolü özel kontrol - sadece view yetkisi varsa apply edemez
              // Department Manager'lar sadece kendilerine verilen permission'lara göre işlem yapabilir
        // Eğer hiç permission yoksa veya sadece view permission'ları varsa apply edemez
      // if (userData.role === "Department Manager") {

      //   if (userPerms.length === 0) {
      //     return false; 
      //   }

      //   const hasOnlyViewPermissions = userPerms.every(
      //     (perm) =>
      //       perm.includes("_menu") ||
      //       perm.includes("view_") ||
      //       perm === "view_events_menu"
      //   );

      //   if (hasOnlyViewPermissions) {
      //     return false; 
      //   }
      // }

      // Eğer kullanıcının sadece view yetkisi varsa (sadece events menüsünü görebilir) apply edemez
      // Bu kullanıcılar sadece görüntüleme yapabilir, işlem yapamazlar
      const hasOnlyViewPermissions =
        userPerms.length > 0 &&
        userPerms.every(
          (perm) =>
            perm.includes("_menu") ||
            perm.includes("view_") ||
            perm === "view_events_menu"
        );

      if (hasOnlyViewPermissions) {
        return false;
      }

      // Normal kullanıcı ise (hiç permission yok veya işlem yapabilecek permission'ları var) apply edebilir
      return true;
    },
    isEventFull(item) {
      const acceptedCount = item.accepted_count || 0;
      const maxParticipants = item.max_participants || 0;
      return acceptedCount >= maxParticipants && maxParticipants > 0;
    },

    initApplySelections() {
      if (this.selectedEvent && this.selectedEvent.is_eft) {
        this.applySessionSelections = {};
        return;
      }
      const sessions = this.selectedEvent && Array.isArray(this.selectedEvent.sessions)
        ? this.selectedEvent.sessions
        : [];
      const next = {};
      sessions.forEach((s) => {
        const addons = this.getApplySessionAddons(s);
        const addonPrefs = {};
        addons.forEach((a) => {
          addonPrefs[a.id] = !!(a.is_required || a.required);
        });
        next[s.id] = { is_attending: true, addon_preferences: addonPrefs };
      });
      this.applySessionSelections = next;
    },
    getApplySessionAddons(session) {
      if (!session) return [];
      const raw = session.addons || session.session_addons || session.add_ons || [];
      const list = Array.isArray(raw) ? raw : [];
      return list.slice().sort((a, b) => {
        const ao = (a && (a.sort_order ?? a.sort)) ?? 0;
        const bo = (b && (b.sort_order ?? b.sort)) ?? 0;
        if (ao !== bo) return ao - bo;
        return String((a && (a.label || a.code)) || '').localeCompare(String((b && (b.label || b.code)) || ''));
      });
    },
    getApplyAddonChecked(sessionId, addon) {
      const s = this.applySessionSelections[sessionId];
      if (!s || !s.addon_preferences) return false;
      return !!s.addon_preferences[addon.id];
    },
    setApplyAddonChecked(sessionId, addon, val) {
      const s = this.applySessionSelections[sessionId];
      if (!s) return;
      if (addon && (addon.is_required || addon.required)) {
        this.$set(s.addon_preferences, addon.id, true);
        return;
      }
      this.$set(s.addon_preferences, addon.id, !!val);
    },
    onApplySessionToggle(session) {
      const s = this.applySessionSelections[session.id];
      if (!s) return;
      const addons = this.getApplySessionAddons(session);
      if (!s.is_attending) {
        addons.forEach((a) => {
          this.$set(s.addon_preferences, a.id, false);
        });
      } else {
        addons.forEach((a) => {
          if (a.is_required || a.required) this.$set(s.addon_preferences, a.id, true);
        });
      }
    },
    buildApplySessionSelectionsPayload() {
      if (this.selectedEvent && this.selectedEvent.is_eft) return null;
      const sessions = this.selectedEvent && Array.isArray(this.selectedEvent.sessions)
        ? this.selectedEvent.sessions
        : [];
      if (!sessions.length) return null;

      return sessions.map((s) => {
        const sel = this.applySessionSelections[s.id] || { is_attending: false, addon_preferences: {} };
        const addons = this.getApplySessionAddons(s);
        return {
          event_session_id: s.id,
          is_attending: !!sel.is_attending,
          addon_preferences: addons.map((a) => ({
            event_session_addon_id: a.id,
            will_attend: !!(sel.addon_preferences && sel.addon_preferences[a.id]),
          })),
        };
      });
    },
    formatSessionRange(session) {
      if (!session || !session.start_at || !session.end_at) return "";
      const start = String(session.start_at || "").replace(" ", "T");
      const end = String(session.end_at || "").replace(" ", "T");
      const startDate = new Date(start);
      const endDate = new Date(end);
      if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) {
        return `${session.start_at} – ${session.end_at}`;
      }
      const pad = (n) => String(n).padStart(2, "0");
      const date = `${pad(startDate.getDate())}-${pad(startDate.getMonth() + 1)}-${startDate.getFullYear()}`;
      const startTime = `${pad(startDate.getHours())}:${pad(startDate.getMinutes())}`;
      const endTime = `${pad(endDate.getHours())}:${pad(endDate.getMinutes())}`;
      return `${date} ${startTime} – ${endTime}`;
    },

    getAttendingAddonPreferences(applicationSession) {
      const prefs = applicationSession && Array.isArray(applicationSession.addon_preferences)
        ? applicationSession.addon_preferences
        : [];
      return prefs.filter((p) => !!p.will_attend);
    },
    formatApplicationSession(applicationSession) {
      const s = applicationSession && applicationSession.session ? applicationSession.session : null;
      const seq = s && (s.sequence_no || s.sequence) ? (s.sequence_no || s.sequence) : null;
      const venue = s && s.venue ? s.venue : null;

      if (!s) {
        return seq ? `Session ${seq}` : `Session #${applicationSession.event_session_id}`;
      }

      let when = "";
      if (s.start_at) {
        when = `${this.formatDate(s.start_at)} ${this.formatTime(s.start_at)}`;
        if (s.end_at) when += ` - ${this.formatTime(s.end_at)}`;
      }

      const parts = [];
      if (seq) parts.push(`Part ${seq}`);
      if (when) parts.push(when);
      if (venue) parts.push(venue);
      return parts.join(" • ") || `Session #${applicationSession.event_session_id}`;
    },

    // Apply Modal Methods
    openApplyModal(event) {
      this.selectedEvent = event;
      this.initApplySelections();
      this.showApplyModal = true;
    },
    resetApplyForm() {
      this.applyForm.reason = "";
      this.applyForm.special_needs = "";
      this.applySessionSelections = {};
      this.selectedEvent = null;
    },
    cancelApplication() {
      this.showApplyModal = false;
      this.resetApplyForm();
    },
    async handleApplySubmit() {
      if (!this.applyForm.reason.trim()) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Required Field",
            text: "Please fill in the required field.",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }

      // Validate based on application method
      const methodInfo = this.getApplicationMethodInfo;
      if (methodInfo) {
        if (methodInfo.inputType === "email") {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(this.applyForm.reason.trim())) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Invalid Email",
                text: "Please enter a valid email address.",
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
            return;
          }
        } else if (methodInfo.inputType === "url") {
          const urlRegex = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
          if (!urlRegex.test(this.applyForm.reason.trim())) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Invalid URL",
                text: "Please enter a valid website URL.",
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
            return;
          }
        }
      }

      if (
        this.selectedEvent &&
        !this.selectedEvent.is_eft &&
        Array.isArray(this.selectedEvent.sessions) &&
        this.selectedEvent.sessions.length
      ) {
        const anySelected = this.selectedEvent.sessions.some(
          (s) => this.applySessionSelections[s.id] && this.applySessionSelections[s.id].is_attending
        );
        if (!anySelected) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Select at least one session",
              text: "Please select at least one session to attend before submitting.",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
      }

      try {
        this.applyLoading = true;
        const userData = JSON.parse(localStorage.getItem("userData"));
        if (!userData || !userData.id) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Not signed in",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return;
        }

        const sessionSelections = this.buildApplySessionSelectionsPayload();

        const createRes = await store.dispatch("events/createApplication", {
          id: this.selectedEvent.id,
          data: {
            user_id: userData.id,
            status: "submitted",
            apply_reason: this.applyForm.reason.trim(),
            special_needs: this.applyForm.special_needs.trim() || null,
            ...(sessionSelections ? { session_selections: sessionSelections } : {}),
          },
        });

        await this.loadUserApplications();
        this.loadActiveEvents();

        const method = createRes.data.manager_approval_required
          ? "manager"
          : "self";
        const title =
          method === "self" ? "Applied Successfully" : "Application Submitted";
        const text =
          method === "self"
            ? "Your application has been submitted and is now under admin review."
            : "Your application has been submitted and is waiting for manager approval.";

        this.$toast({
          component: ToastificationContent,
          props: {
            title: title,
            text: text,
            icon: method === "self" ? "CheckIcon" : "InfoIcon",
            variant: method === "self" ? "success" : "info",
          },
        });

        this.showApplyModal = false;
        this.resetApplyForm();
      } catch (e) {
        console.error("Application error:", e);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            text: e.response?.data?.message || "Application failed",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.applyLoading = false;
      }
    },
    // Send Reminder Methods
    async sendReminderToManagers(item) {
      try {
        this.applicationsLoading = true;

        // Send reminder to all managers
        if (item.event_managers && item.event_managers.length > 0) {
          for (const manager of item.event_managers) {
            await store.dispatch("events/sendReminderToManager", {
              applicationId: item.id,
              managerId: manager.id,
              message: `Please review the pending application for ${item.user_name}.`,
            });
          }

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Reminders Sent",
              text: `Reminders sent to ${item.event_managers.length} manager(s).`,
              icon: "BellIcon",
              variant: "success",
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "No Managers Found",
              text: "No managers found for this application.",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
        }
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            text: e.response?.data?.message || "Failed to send reminders",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.applicationsLoading = false;
      }
    },
    openSpecialNeedsModal(item) {
      // Prefer the embedded user_application on the event item (from /events/active),
      // fall back to the separately-loaded userApplications array.
      const application = item.user_application || this.getUserApplication(item.id);
      this.specialNeedsEventId = item.id;
      this.specialNeedsText = (application && application.special_needs) || "";
      this.showSpecialNeedsModal = true;
    },
    async saveSpecialNeeds() {
      try {
        this.specialNeedsLoading = true;
        await this.$http.patch("applications/special-needs", {
          event_id: this.specialNeedsEventId,
          special_needs: this.specialNeedsText,
        });
        // Update the local application record so the value is current if reopened
        const app = this.getUserApplication(this.specialNeedsEventId);
        if (app) app.special_needs = this.specialNeedsText;
        // Also sync the embedded user_application on the eventsItems entry
        const eventItem = this.eventsItems.find((e) => e.id === this.specialNeedsEventId);
        if (eventItem && eventItem.user_application) {
          eventItem.user_application.special_needs = this.specialNeedsText;
        }

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Saved",
            text: "Your special needs have been updated.",
            icon: "CheckIcon",
            variant: "success",
          },
        });
        this.showSpecialNeedsModal = false;
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            text: e.response?.data?.message || "Failed to save special needs",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.specialNeedsLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard {
  .text-primary {
    font-weight: 600;
  }

  .dashboard-content {
    .b-card {
      transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 4px 25px rgba(0, 0, 0, 0.15);
      }
    }
  }

  .events-tab {
    .table-responsive.b-table-sticky-header {
      max-height: 75vh !important;
    }
  }
  .nested-applications-table {
    tr {
      background-color: #f8f9fa !important;
    }
  }

  ::v-deep tr.eft-row {
    background-color: #e7f3ff !important;
  }

  ::v-deep tr.eft-row:hover {
    background-color: #dbefff !important;
  }

  
}
</style>
